export { default } from './styled';